<button
  shrdUtcLogout
  shrdUicButton
  [disabled]="logoutInProgress"
  [variant]="buttonVariant"
  [class]="buttonClasses"
  (click)="doLogout()"
>
  <ng-content></ng-content>
</button>
<form
  #logoutForm
  *ngIf="logoutDetailsResponse as response"
  [action]="response.cloudSsoLogoutUri"
  method="post"
  novalidate
>
  <ng-container *ngFor="let key of logoutParamKeys">
    <input type="hidden" [name]="key" [value]="response.parameters[key]" />
  </ng-container>
</form>
